import { render } from "./Attendance.vue?vue&type=template&id=0c5f919c&scoped=true&ts=true"
import script from "./Attendance.vue?vue&type=script&lang=ts"
export * from "./Attendance.vue?vue&type=script&lang=ts"

import "./Attendance.vue?vue&type=style&index=0&id=0c5f919c&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5f919c"]])

export default __exports__